import { configureStore } from "@reduxjs/toolkit";
import tradesReducer from '../slices/tradesSlice'
import orderbookReducer from '../slices/orderbookSlice'

export const store = configureStore({
    reducer: {
        trades: tradesReducer,
        orderbook: orderbookReducer,
    }
})